/* eslint-disable @typescript-eslint/consistent-type-definitions */
import * as React from 'react';
import classNames from 'classnames';
import Trigger from 'rc-trigger';
const BUILT_IN_PLACEMENTS = {
    bottomLeft: {
        points: ['tl', 'bl'],
        offset: [0, 4],
        overflow: {
            adjustX: 1,
            adjustY: 1,
        },
    },
    bottomRight: {
        points: ['tr', 'br'],
        offset: [0, 4],
        overflow: {
            adjustX: 1,
            adjustY: 1,
        },
    },
    topLeft: {
        points: ['bl', 'tl'],
        offset: [0, -4],
        overflow: {
            adjustX: 0,
            adjustY: 1,
        },
    },
    topRight: {
        points: ['br', 'tr'],
        offset: [0, -4],
        overflow: {
            adjustX: 0,
            adjustY: 1,
        },
    },
};
function PickerTrigger({ prefixCls, popupElement, popupStyle, visible, dropdownClassName, dropdownAlign, transitionName, getPopupContainer, children, range, popupPlacement, direction, }) {
    const dropdownPrefixCls = `${prefixCls}-dropdown`;
    const getPopupPlacement = () => {
        if (popupPlacement !== undefined) {
            return popupPlacement;
        }
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    };
    return (<Trigger showAction={[]} hideAction={[]} popupPlacement={getPopupPlacement()} builtinPlacements={BUILT_IN_PLACEMENTS} prefixCls={dropdownPrefixCls} popupTransitionName={transitionName} popup={popupElement} popupAlign={dropdownAlign} popupVisible={visible} popupClassName={classNames(dropdownClassName, {
            [`${dropdownPrefixCls}-range`]: range,
            [`${dropdownPrefixCls}-rtl`]: direction === 'rtl',
        })} popupStyle={popupStyle} getPopupContainer={getPopupContainer}>
            {children}
        </Trigger>);
}
export default PickerTrigger;
